import React from "react";

type FilledDiamondProps = {
  filled?: boolean;
  halfFilled?: boolean;
  size?: number;
  color?: string;
  emptyColor?: string;
  filledPercentage?: number;
};

export const FilledDiamond = ({
  filled,
  halfFilled,
  size = 23,
  color = "#facc15",
  emptyColor = "#d1d5db",
  filledPercentage,
}: FilledDiamondProps) => {
  // Génération d'un ID unique pour chaque gradient
  const gradientId = `half-gradient-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      width={size}
      height={(size * 21) / 26}
      viewBox="0 0 26 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      {filledPercentage ? (
        <React.Fragment>
          <defs>
            <linearGradient id={gradientId} x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor={color} />
              <stop offset={`${filledPercentage}%`} stopColor={color} />
              <stop offset={`${filledPercentage}%`} stopColor={emptyColor} />
              <stop offset="100%" stopColor={emptyColor} />
            </linearGradient>
          </defs>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91893 1.20132L2.20935 7.50952L2.4287 7.75834L13.0502 19.7989L23.8912 7.50937L20.1813 1.20117L5.91893 1.20132Z"
            fill={`url(#${gradientId})`}
          />
        </React.Fragment>
      ) : halfFilled ? (
        <>
          <defs>
            <linearGradient id={gradientId} x1="0" x2="1" y1="0" y2="0">
              <stop offset="49%" stopColor={color} />
              <stop offset="51%" stopColor={emptyColor} />
            </linearGradient>
          </defs>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91893 1.20132L2.20935 7.50952L2.4287 7.75834L13.0502 19.7989L23.8912 7.50937L20.1813 1.20117L5.91893 1.20132Z"
            fill={`url(#${gradientId})`}
          />
        </>
      ) : (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.91893 1.20132L2.20935 7.50952L2.4287 7.75834L13.0502 19.7989L23.8912 7.50937L20.1813 1.20117L5.91893 1.20132Z"
          fill={filled ? color : emptyColor}
        />
      )}
    </svg>
  );
};
